import { Stack, Typography, IconButton } from '@mui/material';
import { Icon } from '@/units/index';
import { CountBadge } from '../../../ui/CountBadge';
import { useNotesContext } from '@/components/tour/notes/hooks/useNotesContext';
import { useBoardContext } from '../../hooks/useBoardContext';
import { FAIcon } from '@packages/ui-components';
import { SidebarMode } from '../../config';

export function BoardHeader() {
  const { initialThreads } = useNotesContext();
  const { onBoardClose, onBoardShrink, setSidebarMode } = useBoardContext();

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{ height: '56px', px: '18px', py: '10px', borderBottom: '1px solid var(--Gray-300, #D0D5DD)', backgroundColor: '#fff' }}
    >
      <Stack direction="row" alignItems="center" gap="5px">
        <Typography
          sx={{
            color: 'text.primary',
            fontFamily: 'Inter, sans-serif',
            fontSize: 18,
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '28.873px',
          }}
        >
          Notes
        </Typography>
        {initialThreads.length > 0 && <CountBadge count={initialThreads.length} />}
      </Stack>

      <Stack direction="row" gap="4px">
        <IconButton
          sx={{ width: '36px', height: '36px' }}
          onClick={() => {
            onBoardShrink?.();
          }}
        >
          <Icon.Minimize style={{ fontSize: '22px' }} />
        </IconButton>

        <IconButton sx={{ width: '36px', height: '36px' }} onClick={onBoardClose}>
          <FAIcon icon="faXmark" size={24} color="#101828" />
        </IconButton>
      </Stack>
    </Stack>
  );
}
